import OptimizerEditDto from './OptimizerEditDto';

export class ParticleSwarmOptimizerEditDto extends OptimizerEditDto {
	constructor() {
		super();
		/** @type {number} */
		this.maxIterationCount = null;
		/** @type {number} */
		this.particleCount = null;
		/** @type {number} */
		this.w = null;
		/** @type {number} */
		this.c1 = null;
		/** @type {number} */
		this.c2 = null;
	}

	/**
	 * @typedef {Object} _ParticleSwarmOptimizerEditDtoProps
	 * @property {number} maxIterationCount
	 * @property {number} particleCount
	 * @property {number} w
	 * @property {number} c1
	 * @property {number} c2
	 *
	 * @typedef {import("./OptimizerEditDto").OptimizerEditDtoProps & _ParticleSwarmOptimizerEditDtoProps} ParticleSwarmOptimizerEditDtoProps
	 */
	/**
	 *
	 * @param {ParticleSwarmOptimizerEditDtoProps} props
	 * @returns {ParticleSwarmOptimizerEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.maxIterationCount = props.maxIterationCount;
		this.particleCount = props.particleCount;
		this.w = props.w;
		this.c1 = props.c1;
		this.c2 = props.c2;
		return this;
	}
}

export default ParticleSwarmOptimizerEditDto;
